import { Table, TableWrapper, Tbody, Td, Th, Thead, Tr } from '@components/core-ui/Table';
import Done from '@components/icons/Done.svg';
import { LinearProgressLoader } from '@components/core-ui/spinners/LinearProgressLoader';
import { getAmericanTime } from '@helpers/getAmericanTimezone';
import { useAPI } from '@providers/useAPI';
import { routes } from '@routes';
import { useQuery } from '@tanstack/react-query';
import { CourseResponseDto } from 'app/API';
import { canvasKeys } from 'app/queries/canvas/canvasKeys';
import { Link } from 'react-router-dom';
import { createFetchCanvasCoursesQueryFn } from '../../api/fetchCanvasCourses';
import { Wrapper } from './styles/Wrapper';

export const Content = () => {
  const { call } = useAPI();

  const coursesQuery = useQuery({
    queryKey: canvasKeys.courses(),
    queryFn: createFetchCanvasCoursesQueryFn(call),
  });
  const courses = coursesQuery.data ?? [];

  return (
    <Wrapper>
      <LinearProgressLoader active={coursesQuery.isFetching} />
      <TableWrapper>
        <Table>
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th>Students</Th>
              <Th>Created</Th>
              <Th>Published</Th>
            </Tr>
          </Thead>
          <Tbody>
            {courses.map((data: CourseResponseDto) => (
              <Tr key={data.id}>
                <Td>
                  <p className="cell">{data?.name}</p>
                </Td>
                <Td>
                  <p className="cell">
                    <Link to={routes.adminCanvasCourseStudentsPage.make(String(data.id))} className="underline">
                      {data?.total_students || 0}
                    </Link>
                  </p>
                </Td>
                <Td>
                  <p className="cell">{getAmericanTime(data.created_at)}</p>
                </Td>
                <Td>
                  <p className="cell">{data.is_public ? <Done width="16px" /> : ''}</p>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableWrapper>
    </Wrapper>
  );
};
